<template>
  <div class="detail">
    <hight-light :text="info.name" :bg-text="info.name" :english="info.english" :is-bg="true"/>
    <el-button class="back" type="primary" plain @click="back">返回</el-button>
    <div class="content">
      <div class="tag-box" v-if="info.advantage">
        <span>产品优势和特点：{{ info.advantage }}</span>
      </div>
      <div class="detail-box">
        <div class="title">产品简介</div>
        <div class="desc-box">
          <img v-if="info.image" :style="{width: (info.id === '31' || info.id === '41' ? '800px' : '400px')}" :src="info.image" alt="">
          <img v-if="info.image1" :src="info.image1" alt="">
          <div class="letter">
            <div class="desc" v-for="(item, index) in info.desc" :key="index">
              {{ item }}
            </div>
            <div class="desc" v-for="item in info.engDesc" :key="item">
              {{ item }}
            </div>
          </div>
        </div>
        <div class="title" v-if="info.id === '12' || info.id === '31'" style="margin-top: 16px">设备特点与优势( Equipment characteristics and advantages )</div>
        <div class="advantage-box" v-if="info.id === '12' || info.id === '31'">
          <div class="advantage-item" v-for="(item, index) in info.advantageList" :key="index">
            <div class="red"><i class="el-icon-star-on red"></i>{{ item.title }}</div>
            <div class="black">{{ item.chinese }}</div>
            <div class="gray">{{ item.english }}</div>
          </div>
        </div>
        <div class="title" v-if="info.imageList && info.imageList.length > 0" style="margin-top: 16px">主要技术参数</div>
        <div class="column-center" v-if="info.imageList && info.imageList.length > 0">
          <span v-for="(item, index) in info.imageList" :key="index">
            <img :src="item" alt="">
          </span>
        </div>
      </div>
    </div>
<!--    <img :src="image" >-->
  </div>
</template>

<script>
import { projects } from "@/assets/project";
import HightLight from "@/components/common/hightLight/HightLight";
import { eduProducts,lanProducts,indProducts } from "@/assets/products";
export default {
  name: "Detail",
  components:{ HightLight, },
  data(){
    return{
      eduProducts,
      lanProducts,
      indProducts,
      projects,
      id:0,
      name: '',
      image: '',
      english: '',
      info: {}
    }
  },
  created (){
    this.init()
  },
  methods: {
    init () {
      this.id = this.$route.query.id
      this.handleDetail()
    },
    handleDetail () {
      let crusherIds = ['1', '2', '11', '12', '21', '22', '31', '32', '41']
      let screenIds = ['3', '4']
      if(crusherIds.includes(this.id)) {
        eduProducts.map(item => {
          if(item.id === this.id) {
            this.info = item
            console.log(this.info, '????')
          }
        })
      } else if (screenIds.includes(this.id)) {
        lanProducts.map(item => {
          if(item.id === this.id) {
            this.info = item
            console.log(this.info)
          }
        })
      } else {
        indProducts.map(item => {
          if(item.id === this.id) {
            this.info = item
            console.log(this.info)
          }
        })
      }
    },
    back () {
      this.$router.back()
    }
  }
}
</script>

<style lang="less" scoped>
  .detail{
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    .back {
      width: 100px;
      margin-bottom: 16px;
    }
    .content {
      .tag-box {
        color: #f56c6c;
        border: 1px dashed #f56c6c;
        font-size: 20px;
        padding: 16px;
        margin-bottom: 16px;
      }
      .detail-box {
        margin: 16px;
        .title {
          padding: 0 0 0 16px;
          border-left: 6px solid #3a8ee6;
          font-size: 22px;
          color: #3a8ee6;
          margin-bottom: 16px;
        }
        .desc-box {
          display: flex;
          img {
            width: 400px;
            height: 350px;
          }
          .letter {
            margin-left: 16px;
            display: flex;
            flex-direction: column;
            flex: 1;
          }
          .desc {
            display:flex;
            white-space: pre-wrap;
            text-indent: 2em;
            line-height: 26px
          }
        }
      }
    }
    .column-center {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
    }
    .advantage-box {
      .advantage-item {
        font-size: 18px;
        .red {
          margin-top: 8px;
          color: #F15454;
        }
        .black {
          margin-top: 8px;
          padding-left: 22px;
          color: #444444;
        }
        .gray {
          margin-top: 8px;
          padding-left: 22px;
          color: rgba(39, 46, 58, 0.8);
        }
      }
    }
  }
</style>
